import { Link, Outlet, useLocation } from 'react-router'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/about.ts'

const tabs = [
	{ label: 'The Team', to: '/about/team' },
	{ label: 'Our Players', to: '/about/players' },
	{ label: 'Mission', to: '/about/mission' },
	{ label: 'Code of Conduct', to: '/about/code-of-conduct' },
	{ label: 'USBGF', to: '/about/usbgf' },
]

function handleTabClick(to: string) {
	sessionStorage.setItem('about-last-tab', to)
}

export async function loader() {
	const tagline = await safeFetch<string | null>(
		`*[_type == "aboutPage"][0].tagline`,
	)
	return { tagline }
}

export const meta: Route.MetaFunction = () => [
	{ title: 'About Steel City Backgammon' },
]

export default function AboutLayout({ loaderData }: Route.ComponentProps) {
	const location = useLocation()

	return (
		<main className="font-poppins w-[calc(100%-12px)]">
			<div className="mx-auto max-w-5xl px-4">
				<h1 className="text-center text-4xl">About Us</h1>
				{loaderData.tagline ? (
					<p className="mt-4 text-center text-xl text-slate-600 dark:text-slate-400">
						{loaderData.tagline}
					</p>
				) : null}
				<nav className="mt-4 mb-8 flex flex-wrap justify-center gap-1 border-b border-slate-200 dark:border-slate-700">
					{tabs.map((tab) => {
						const isActive = location.pathname === tab.to
						return (
							<Link
								key={tab.to}
								to={tab.to}
								onClick={() => handleTabClick(tab.to)}
								className={
									isActive
										? 'border-b-2 border-slate-900 px-4 pb-2 text-sm font-semibold dark:border-slate-100'
										: 'px-4 pb-2 text-sm text-slate-500 hover:text-slate-900 dark:hover:text-slate-100'
								}
							>
								{tab.label}
							</Link>
						)
					})}
				</nav>
			</div>
			<Outlet />
		</main>
	)
}
